import { render, staticRenderFns } from "./AdminEmailsRoute.vue?vue&type=template&id=b680152c"
import script from "./AdminEmailsRoute.vue?vue&type=script&lang=js"
export * from "./AdminEmailsRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports